<template>
    <div class="ac-floating-panel provider-card-skeleton-wrap">
        <div class="ac-panel-content ac-white-panel provider-card-skeleton">
            <div class="skeleton-row">
                <div class="skeleton-avatar skel-shimmer" aria-hidden="true"></div>
                <div class="skeleton-text-col">
                    <div class="skeleton-line skel-shimmer w-55"></div>
                    <div class="skeleton-line skel-shimmer w-35"></div>
                    <div class="skeleton-line skel-shimmer w-45"></div>
                    <div class="skeleton-badge skel-shimmer w-40"></div>
                </div>
                <div class="skeleton-contact-col">
                    <div class="skeleton-line skel-shimmer w-70"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProviderCardSkeleton",
};
</script>

<style scoped>
.provider-card-skeleton-wrap {
    margin-top: 10px;
}

.provider-card-skeleton {
    padding: 24px;
}

.skeleton-row {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.skeleton-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    flex-shrink: 0;
}

.skeleton-text-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
}

.skeleton-contact-col {
    flex-shrink: 0;
    min-width: 100px;
}

.skeleton-line {
    height: 14px;
    border-radius: 6px;
}

.skeleton-badge {
    height: 26px;
    border-radius: 999px;
    margin-top: 4px;
}

.w-35 {
    width: 35%;
}

.w-40 {
    width: 40%;
}

.w-45 {
    width: 45%;
}

.w-55 {
    width: 55%;
}

.w-70 {
    width: 70%;
}

.skel-shimmer {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 1000px 104px;
}

@keyframes placeHolderShimmer {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}

@media (max-width: 768px) {
    .skeleton-row {
        flex-direction: column;
        align-items: center;
    }

    .skeleton-contact-col {
        width: 100%;
    }

    .skeleton-line.w-70 {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>
